import { useRef, useMemo } from 'react';

// src/hooks/useMemoizedFn.ts
function useMemoizedFn(fn) {
  {
    if (typeof fn !== "function") {
      console.error(`useMemoizedFn expected parameter is a function, got ${typeof fn}`);
    }
  }
  const fnRef = useRef(fn);
  fnRef.current = useMemo(() => fn, [fn]);
  const memoizedFn = useRef();
  if (!memoizedFn.current) {
    memoizedFn.current = function(...args) {
      return fnRef.current.apply(this, args);
    };
  }
  return memoizedFn.current;
}

export { useMemoizedFn };
